module.exports = __webpack_public_path__ + "static/media/book3.5a132928.svg";